import { defineComponent as _defineComponent } from 'vue'

import SvgAttention from "@/assets/icons/attention-symbol.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAlert',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
    text?: string,
}

// @ts-ignore


return { __sfc: true,props, SvgAttention }
}

})